(function() {
    // 注册组件
    SR.modules.extend('answer', answer);

    function answer() {
        // 仅提供命名空间
    }
})();